// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2JLbY","imageUploader":"EGiftCard_imageUploader__37IWo"};